var map = {
	"./check-1.svg": "./src/assets/icons/check-1.svg",
	"./chevron-left.svg": "./src/assets/icons/chevron-left.svg",
	"./chevron-right.svg": "./src/assets/icons/chevron-right.svg",
	"./close.svg": "./src/assets/icons/close.svg",
	"./done-circle.svg": "./src/assets/icons/done-circle.svg",
	"./filter.svg": "./src/assets/icons/filter.svg",
	"./information-desk-question-help.svg": "./src/assets/icons/information-desk-question-help.svg",
	"./loading.svg": "./src/assets/icons/loading.svg",
	"./login-keys.svg": "./src/assets/icons/login-keys.svg",
	"./logout-2.svg": "./src/assets/icons/logout-2.svg",
	"./password-hide.svg": "./src/assets/icons/password-hide.svg",
	"./password-show.svg": "./src/assets/icons/password-show.svg",
	"./pencil-circle.svg": "./src/assets/icons/pencil-circle.svg",
	"./pencil.svg": "./src/assets/icons/pencil.svg",
	"./register.svg": "./src/assets/icons/register.svg",
	"./settings-user.svg": "./src/assets/icons/settings-user.svg",
	"./single-neutral-circle.svg": "./src/assets/icons/single-neutral-circle.svg",
	"./submit.svg": "./src/assets/icons/submit.svg",
	"./warning-circle.svg": "./src/assets/icons/warning-circle.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";